import { SUPPORTED_LANGUAGES } from '@/shared/config';
import type { NavItem } from './types';

const LANGUAGE_PREFIX = new RegExp(
  `^/(${SUPPORTED_LANGUAGES.join('|')})(?=/|$)`
);

const stripLanguagePrefix = (pathname: string) => {
  const stripped = pathname.replace(LANGUAGE_PREFIX, '');
  return stripped === '' ? '/' : stripped;
};

const matchesPath = (pathname: string, pattern: string) => {
  if (pattern === '/') {
    return pathname === '/';
  }

  return pathname === pattern || pathname.startsWith(`${pattern}/`);
};

export const isNavItemActive = (
  item: Pick<NavItem, 'href' | 'activePatterns'>,
  pathname: string
) => {
  const current = stripLanguagePrefix(pathname);
  const patterns = [item.href, ...(item.activePatterns ?? [])].filter(Boolean);

  return patterns.some(pattern => matchesPath(current, pattern));
};
